export default "__VITE_PUBLIC_ASSET__004e3d17__"